module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAUCAYAAACEYr13AAAAcUlEQVQ4EaXBsQ3AMAzAMOn/o12NgScDJeUn+UmWCQeGyDLhwBBZJhwYIsuEA0NkmfAwZMLDEFkmPAyZ8DBElgkHhsgy4cAQWSYcGCLLhAND5GjCwxA5mvAwRJYJB4bIMuHAEFkmHBgiy4QDQ+Qn+ekDlJdIFWdtJyoAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/flappybird/number_score_09.png
// module id = 242
// module chunks = 0